import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import EditGestanteForm from '../../components/Forms/EditGestanteForm';
import TimelineTable from '../../components/TimelineTable/TimelineTable';
import ToastManager from '../../components/Toast/ToastManager';
import { useToast } from '../../hooks/useToast';
import api from '../../services/api';

const GestanteEditPage = () => {
  const { cpf } = useParams();
  const { toasts, removeToast, showSuccess, showError } = useToast();
  console.log("Valor do CPF: ",cpf)

  const [gestanteData, setGestanteData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGestanteData = async () => {
      try {
        const response = await api.get(`/gestante/${cpf}/list`);
        if (!response.status==200) throw new Error('Erro ao buscar dados');
        const data = response.data;
        setGestanteData(data);
      } catch (err) {
        console.error("Erro ao buscas dados:", err)
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (cpf) {
      fetchGestanteData();
    }
  }, [cpf]);

  if (loading) return <p>Carregando...</p>;
  if (error) return <p>Erro: {error}</p>;

  console.log("Dados recebidos da API:", gestanteData);

  return (
    <div>
      <h1>Editar Gestante</h1>
      {gestanteData && <EditGestanteForm gestante={gestanteData} />}
      
      {gestanteData && (
        <TimelineTable
          gestante={gestanteData}
          showSuccess={showSuccess}
          showError={showError}
        />
      )}

      {/* Toast Manager para notificações */}
      <ToastManager toasts={toasts} removeToast={removeToast} />
    </div>
  );
};

export default GestanteEditPage;
